import { render, staticRenderFns } from "./CV.vue?vue&type=template&id=b064273a&scoped=true"
import script from "./CV.vue?vue&type=script&lang=js"
export * from "./CV.vue?vue&type=script&lang=js"
import style0 from "./CV.vue?vue&type=style&index=0&id=b064273a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b064273a",
  null
  
)

export default component.exports